import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import bannerImage from '../../assets/bannerImage01.png';
import styles from './CompanyInfo.module.scss';
import { useTranslation } from 'react-i18next';
function CompanyInfo() {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <Header />
      <div className={styles.contentWrap}>
        <img src={bannerImage} alt="image" />
        <div className={styles.textWrap}>
          <h3>{t('home.56')}</h3>
          <p>{t('home.57')}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default CompanyInfo;
